import {
  MENU_CATEGORY_ALL,
  MENU_CATEGORY_CREATE,
  MENU_CATEGORY_DELETE,
  MENU_CATEGORY_GET,
  MENU_CATEGORY_UPDATE,
} from "../../actions/types"

const initialState = {
  roomtypes: null,
  isLoading: false,
}
export default function MenuCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case MENU_CATEGORY_ALL:
      return {
        arr: action.payload?.rows,
        currPage: action.payload?.currPage,
        lastPage: action.payload?.lastPage,
        isLoading: true,
      }
    case MENU_CATEGORY_GET:
      return {
        ...action.payload,
        isLoading: true,
      }
    case MENU_CATEGORY_CREATE:
      return { isLoading: true }
    case MENU_CATEGORY_UPDATE:
      return { isLoading: true }
    case MENU_CATEGORY_DELETE:
      return { isLoading: true }
    default:
      return state
  }
}
